import React from 'react'
import {CSSTransitionGroup} from 'react-transition-group'

export default class Questions extends React.Component{
	constructor(props) {
		super(props)
		this.state = {
			questionID: 0
		}
	}

	setQuestionID = () => {
		const {questionID} = this.state 
		let newQuestionID = questionID +1
		this.setState({
			questionID: newQuestionID
		})
	}

	onButtonClick = e => {
		let currentClassList = e.currentTarget.classList
		currentClassList.add('button--active-reverse')
		document.getElementsByClassName('options')[0].classList.add('options--no-click')

		const {handler, data} = this.props
		const {questionID} = this.state
		const questionAmount = data.questions.questions.length
		const _this = this
		setTimeout(function(){ 
			if((questionID + 1) === questionAmount){
				handler()
			} else {
				_this.setQuestionID()
			}
		}, 300)
	}

	render(){
		const {
			data,
			handler,
			name
		} = this.props 

		const {questionID} = this.state

		const questionscreenData = data.questions
		const text = questionscreenData.text
		const questionData = questionscreenData.questions[questionID].field
		const namePlaceholder = questionscreenData.placeholder
		let question = questionData.text
		let splitName = name.split(/[ ,]+/)
		if(splitName[0]){
			if(question.indexOf("{name}s") !== -1 && splitName[0].toLowerCase().slice(-1) === 's'){
				question = question.replace(new RegExp('{name}s', 'g'),splitName[0] + "'")
			} else if(question.indexOf("{name}’s") !== -1 && splitName[0].toLowerCase().slice(-1) === 's'){
				question = question.replace(new RegExp("{name}’s", 'g'),splitName[0] + "'")
			} else {
				question = question.replace(new RegExp('{name}', 'g'),splitName[0])
			}
		} else {
			//question = question.replace('{name}', namePlaceholder)
			question = question.replace(new RegExp('{name}', 'g'), namePlaceholder)
		}
		const options = questionData.options
		const questionAmount = questionscreenData.questions.length
		const _this = this
		const duration = 1000

		return(
			<CSSTransitionGroup
				transitionName='slideup'
				transitionAppear={true}
				transitionAppearTimeout={duration}
				transitionEnterTimeout={duration}
				transitionLeaveTimeout={duration}>
				<div key={questionID} className='questions'>
					<div className='text'>{text} {questionID + 1}/{questionAmount}</div>
					<div className='question'>{question}</div>
					<div className='options'>
						{options.map(function(button,index){
							let buttonName = button.field
							return (
								<div key={index} className='button button--reverse' onClick={_this.onButtonClick}>{buttonName}</div>
							)
						})}
					</div>
				</div>
			</CSSTransitionGroup>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/splitScreen/subcomponents/questions.js